import React, { useEffect } from 'react';
import { Select } from 'antd';
import Cell from '../../Cell/Cell';
import { notDraggableClass } from '../../../constants/common';
import { useDispatch, useSelector } from 'react-redux';
import { serviceCompanyValueSelector } from '../../../store/selectors';
import { setServiceCompanyValue } from '../../../store/actions';
import useServiceCompanies from '../../../queries/useServiceCompanies';

const { Option } = Select;

const ChooseCompany = () => {
  const dispatch = useDispatch();

  const { data: companies = [], isFetching } = useServiceCompanies();
 
  const serviceCompany = useSelector(serviceCompanyValueSelector);
 
  const handleChange = (value) => {
    const serviceCompanySelected = companies.find(
      (option) => option.id === Number(value)
    );

    dispatch(setServiceCompanyValue(serviceCompanySelected));
  };

  useEffect(() => {
    if (!!companies?.length) {
      dispatch(setServiceCompanyValue(companies?.[0]));
      return;
    }

    dispatch(setServiceCompanyValue(null));
  }, [companies, dispatch]);

  return (
    <Cell
      title="Исходящий вызов от УК:"
      className={notDraggableClass}
      content={
        <Select
          showSearch
          placeholder="Выберите компанию"
          notFoundContent="нет данных"
          optionFilterProp="searchtext"
          onChange={handleChange}
          getPopupContainer={(trigger) => trigger.parentNode}
          value={serviceCompany ? serviceCompany.id : null}
          loading={isFetching}
        >
          {companies.map((option) => (
            <Option key={option.id} value={option.id} searchtext={option.name}>
              {`${option.shortName} ${option.phone}`}
            </Option>
          ))}
        </Select>
      }
    />
  );
};

export default ChooseCompany;
